import { Content } from '../../types';

export const similanIslandsContent: Content = {
  title: 'איי סימילאן – פנינת טבע בים אנדמן',
  imageUrl: '/images/thailand/similan-islands/similan-islands-wide.jpg',
  introduction:
    'איי סימילאן הינם קבוצה בת אחד עשר איים טרופיים עוצרי נשימה, הידועים ביופיים הטבעי, במימיהם הצלולים ובחולותיהם הלבנים. האיים ממוקמים כ-60 ק"מ מערבית לקאו לאק, בלב ים אנדמן, ושייכים לתאילנד. בשל ערכם האקולוגי הייחודי, האזור הוכרז כפארק לאומי ימי ונחשב לאחד מאתרי הצלילה והשנורקלינג הטובים בעולם.',
  sections: [
    {
      title: 'איי סימילאן',
      type: 'image',
      imageUrl:
        '/images/thailand/similan-islands/similan-islands-article-1.jpg',
      content: '',
    },
    {
      title: 'עולם תת-ימי עשיר',
      type: 'text',
      content:
        'איי סימילאן מציעים חוויית צלילה מהטובות בתאילנד. המים הצלולים חושפים שוניות אלמוגים צבעוניות, מערות תת-מימיות, להקות דגים אקזוטיים, צבי ים ואפילו כרישי לוויתן בעונות מסוימות. האיים מהווים בית גידול למגוון ביולוגי רחב של בעלי חיים ימיים וצמחייה ימית ייחודית.',
    },
    {
      title: 'עונת הביקור',
      type: 'text',
      content:
        'הפארק הלאומי איי סימילאן פתוח למבקרים בעונה היבשה – בדרך כלל בין אמצע אוקטובר לאמצע מאי. תאריכי הפתיחה והסגירה המדוייקים משתנים מדי שנה בהתאם לתנאי מזג האוויר, ולכן מומלץ לבדוק מראש את מועדי הביקור הרשמיים. במהלך העונה הרטובה, האיים סגורים כדי להגן על המערכת האקולוגית ולשמור על בטיחות המבקרים.',
    },
    {
      title: 'הגעה לאיים',
      type: 'text',
      content:
        'ההגעה לאיים מתבצעת באמצעות שייט מהיר (Speed Boat) היוצא בעיקר מהמזח בקאו לאק ונמשך קצת יותר משעה. קיימים גם טיולים מאורגנים היוצאים מפוקט, אך יש לקחת בחשבון כי נסיעה מפוקט לנקודת היציאה בקאו לאק מוסיפה כשעתיים לכל כיוון.',
    },
    {
      title: 'טיולים ופעילויות באיים',
      type: 'text',
      content:
        'מלבד צלילה ושנורקלינג, המבקרים יכולים ליהנות ממסלולי הליכה קצרים המובילים לנקודות תצפית מרהיבות על הנוף הטרופי והחופים המרהיבים. חלק מהאיים מציעים חופים ייחודיים, כגון חוף Donald Duck Bay באי מספר 8, הידוע בשל סלעי הגרניט הגדולים המקנים לו מראה ייחודי.',
    },
    {
      title: 'שמירה על הטבע והגבלות ביקור',
      type: 'text',
      content:
        'בשל הפופולריות של האתר והצורך בשימור הטבע, כמות המבקרים והצוללים היומית מוגבלת. בעונות השיא ובחגים מקומיים, מומלץ להזמין כרטיסים מראש כדי להבטיח מקום. כמו כן, חל איסור על שהיית לילה באיים והלינה מתבצעת בקאו לאק או בפוקט.',
    },
    {
      title: 'טיפים למטיילים',
      type: 'sub-headers',
      description:
        'להלן מספר טיפים חשובים שיעזרו לכם להפיק את המרב מהביקור באיי סימילאן:',
      content: [
        {
          subtitle: 'בחירת חברת טיולים',
          text: 'מומלץ לצאת לטיול עם חברה מוכרת כדי להבטיח חוויית ביקור בטוחה ונעימה.',
        },
        {
          subtitle: 'קרם הגנה ידידותי לסביבה',
          text: 'יש להביא קרם הגנה ידידותי לשונית האלמוגים כדי לסייע בשמירה על המערכת האקולוגית הימית.',
        },
        {
          subtitle: 'ציוד שנורקלינג',
          text: 'לא לשכוח ציוד מתאים לשנורקלינג, אם כי מרבית החברות מספקות ציוד כחלק מהטיול.',
        },
      ],
    },
    {
      title: 'סיכום',
      type: 'text',
      content:
        'בשורה התחתונה, איי סימילאן הינם יעד חלומי לחובבי טבע, צלילה ושנורקלינג ומציעים חוויית ביקור בלתי נשכחת בלב ים אנדמן. שמירה על הסביבה והזמנת כרטיסים מראש יסייעו לכם ליהנות מהקסם הייחודי של האיים הללו בצורה אחראית ומושכלת.',
    },
  ],
};
